import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import Link from 'next-translate-routes/link';

import { TextareaField } from '@components/molecules/TextareaField';
import { TextField } from '@components/molecules/TextField';

import { IProps } from './types';

import { commonMessages, validationCommonMsg } from '../../../../intl';

import * as S from './styles';

export const ContactsForm: React.FC<IProps> = ({
  handleSubmit: submit,
  defaultValues,
  ...props
}: IProps) => {
  const {
    control,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues,
  });

  const watchFields = watch();

  const intl = useIntl();

  const [accepted, setAccepted] = useState(false);

  return (
    <S.ContactsForm className="contact-form" onSubmit={handleSubmit(submit)}>
      <S.Wrapper>
        <>
          <S.RowWithOneCell margin>
            <Controller
              name="subject"
              control={control}
              rules={{
                required: intl.formatMessage(validationCommonMsg.required),
              }}
              render={({ field }) => (
                <TextField
                  whiteBg
                  label={intl.formatMessage(commonMessages.subject)}
                  autoComplete="given-name"
                  maxLength={100}
                  errors={
                    errors.subject
                      ? [{ message: errors.subject.message }]
                      : undefined
                  }
                  {...field}
                />
              )}
            />
          </S.RowWithOneCell>
          <S.CharactersCounter>
            {100 - (watchFields.subject?.length || 0)}{' '}
            {intl.formatMessage(commonMessages.charactersLeft)}
          </S.CharactersCounter>
          <S.RowWithOneCell>
            <Controller
              name="customerEmail"
              control={control}
              rules={{
                pattern: {
                  message: intl.formatMessage(validationCommonMsg.invalidEmail),
                  value:
                    /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                },
                required: intl.formatMessage(validationCommonMsg.required),
              }}
              render={({ field }) => (
                <TextField
                  whiteBg
                  label={intl.formatMessage(commonMessages.yourEmailAddress)}
                  autoComplete="email"
                  errors={
                    errors.customerEmail
                      ? [{ message: errors.customerEmail.message }]
                      : undefined
                  }
                  {...field}
                />
              )}
            />
          </S.RowWithOneCell>
          <S.RowWithOneCell margin>
            <Controller
              name="message"
              control={control}
              rules={{
                required: intl.formatMessage(validationCommonMsg.required),
              }}
              render={({ field }) => (
                <TextareaField
                  whiteBg
                  label={intl.formatMessage(commonMessages.yourMessage)}
                  maxLength={1200}
                  errors={
                    errors.message
                      ? [{ message: errors.message.message }]
                      : undefined
                  }
                  {...field}
                />
              )}
            />
          </S.RowWithOneCell>
          <S.CharactersCounter>
            {1200 - watchFields.message.length}{' '}
            {intl.formatMessage(commonMessages.charactersLeft)}
          </S.CharactersCounter>
          <S.RowWithOneCell margin>
            <S.StyledCheckbox
              name="accepted"
              checked={accepted}
              onChange={() => setAccepted((v) => !v)}
              color="primary"
            >
              {intl.formatMessage(commonMessages.accept)}
              <Link href="/">
                <a>{intl.formatMessage(commonMessages.termsOfService)}</a>
              </Link>
            </S.StyledCheckbox>
          </S.RowWithOneCell>
          <S.RowWithOneCell margin>
            <S.StyledButton type="submit" disabled={!accepted}>
              {intl.formatMessage(commonMessages.send)}
            </S.StyledButton>
          </S.RowWithOneCell>
        </>
      </S.Wrapper>
    </S.ContactsForm>
  );
};
